import { UiStatuspageModel } from "../../models";

export function mockUiStatuspageModel({
    id = "StatusPage-1234",
    type = "uiStatuspage",
    locale = "en",
    content = mockUiStatuspageModelContent()
}: Partial<UiStatuspageModel> = {}): UiStatuspageModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiStatuspageModelContent = UiStatuspageModel["content"];

export function mockUiStatuspageModelContent({
    title = "Example Statuspage component",
    statuspageId = "trello",
    none = "All systems 👍",
    minor = "Minor incident!",
    major = "Major incident!",
    critical = "Critical incident!",
    url = "https://trello.status.atlassian.com/",
    ...optionals
}: Partial<UiStatuspageModelContent> = {}): UiStatuspageModelContent {
    return {
        title,
        statuspageId,
        none,
        minor,
        major,
        critical,
        url,
        ...optionals
    };
}
